<template>
  <div class="holiday-main-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right">
            <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="holiday-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="holiday-head">
        <img class="head-img-back" src="./images/main-bg.png" />

        <div class="head-con">
          <div class="head-img" :style="{ 'margin-top': `${barHeight + 42}px` }">
            <img :src="getMatchTitle('tit-bg-', $i18n.locale)" />
          </div>

          <div class="dead-line">
            <div class="timer">
              <span class="time-num">
                <span>{{ countdownResult.days }}</span>
                <i>{{ $t('lang.commonM.k297') }}</i>
              </span>
              <span class="stp">:</span>
              <span class="time-num">
                <span>{{ countdownResult.hours }}</span>
                <i>{{ $t('lang.commonM.k364') }}</i>
              </span>
              <span class="stp">:</span>
              <span class="time-num">
                <span>{{ countdownResult.minutes }}</span>
                <i>{{ $t('lang.commonM.k365') }}</i>
              </span>
              <span class="stp">:</span>
              <span class="time-num">
                <span>{{ countdownResult.seconds }}</span>
                <i>{{ $t('lang.commonM.k366') }}</i>
              </span>
            </div>
          </div>

          <div v-if="actInfo" class="points-rank">
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k221') }}</div>
              <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
            </div>
            <div class="pr-gap"></div>
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k222') }}</div>
              <div>{{ actInfo.rank || '--' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-con">
        <!-- Leaderboard Rewards -->
        <div class="part-block" style="margin-top: 0">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k420') }}</div>
          <div class="holiday-reward">
            <div class="holiday-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                {{ boardData.num1Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                {{ boardData.num2Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                {{ boardData.num3Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                {{ boardData.num4Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div class="holiday-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <!-- Milestone Rewards -->
        <div class="part-block" style="background: #f2f7fa">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k215') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k421') }}</div>
          <div v-if="actInfo && actInfo.milestoneStates && actInfo.milestoneRewards" class="part-percent">
            <div class="progress-box">
              <!-- 左 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[0] === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    {{ actInfo.milestoneRewards[0] }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[0] === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[0] === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[0] === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 中 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[1] === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    {{ actInfo.milestoneRewards[1] }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[1] === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[1] === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[1] === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 右 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[2] === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    {{ actInfo.milestoneRewards[2] }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[2] === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[2] === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[2] === 0" class="box" src="./images/box.png" />
              </div>
            </div>
            <div class="progress-wraper">
              <div class="progress-bar">
                <div class="step step0" :class="{ on: actInfo.milestoneStates[0] > 0 }"></div>
                <div class="step step1" :class="{ on: actInfo.milestoneStates[1] > 0 }"></div>
                <div class="step step5" :class="{ on: actInfo.milestoneStates[2] > 0 }"></div>
                <div class="progress-trace" :style="{ width: mePosition }">
                  <div class="me"></div>
                </div>
              </div>
            </div>
            <div class="progress-points">
              <div class="points-name">{{ $t('lang.valRuFe.points') }}:</div>
              <div class="points-num">
                <div>10</div>
                <div>30</div>
                <div>50</div>
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div v-if="canClaim == 'canClaim'" class="holiday-btn" @click="handleClaim()">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'canNotClaim'" class="holiday-btn btn-disable">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'claimed'" class="holiday-btn btn-disable">{{ $t('lang.commonM.k074') }}</div>
          </div>
        </div>

        <!-- Special event gifts -->
        <div class="part-block" style="background: #f4faf2">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k448') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k455') }}</div>
          <div class="holiday-gift">
            <div class="gift-round">
              <div class="gift-cost">+1 {{ $t('lang.commonM.k260') }}</div>
              <div class="gift-img">
                <img src="@/assets/packageAssets/common/Gem.png" alt="" />
              </div>
              <div class="gift-name">{{ $t('lang.commonM.k454') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+3 {{ $t('lang.commonM.k260') }}</div>
              <div class="gift-img">
                <img src="@/assets/packageAssets/common/Ring.png" alt="" />
              </div>
              <div class="gift-name">{{ $t('lang.commonM.k211') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+7 {{ $t('lang.commonM.k260') }}</div>
              <div class="gift-img">
                <img src="@/assets/packageAssets/common/Fireworks.png" alt="" />
              </div>
              <div class="gift-name">{{ $t('lang.commonM.k451') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+15 {{ $t('lang.commonM.k260') }}</div>
              <div class="gift-img">
                <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
              </div>
              <div class="gift-name">{{ $t('lang.commonM.k305') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+80 {{ $t('lang.commonM.k260') }}</div>
              <div class="gift-img">
                <img src="@/assets/packageAssets/common/Candy.png" alt="" />
              </div>
              <div class="gift-name">{{ $t('lang.commonM.k214') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showReward" class="mask">
      <div class="dia-con">
        <div class="reward-item">
          <span>{{ reward }}</span>
          <img :src="getMatchImg('beans')" alt="" />
        </div>

        <p class="dia-tips">{{ $t('lang.commonM.k378') }}</p>

        <div class="rules-btn" @click="showReward = false">{{ $t('lang.ok') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo, holidayMilesClaim } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'

// en
import vavaTitBgEn from './images/vava/female-bg-en.png'
import echoTitBgEn from './images/echo/female-bg-en.png'
import joychatTitBgEn from './images/joychat/female-bg-en.png'
import kikoTitBgEn from './images/kiko/female-bg-en.png'

// es
import vavaTitBgEs from './images/vava/female-bg-es.png'
import echoTitBgEs from './images/echo/female-bg-es.png'
import joychatTitBgEs from './images/joychat/female-bg-es.png'
import kikoTitBgEs from './images/kiko/female-bg-es.png'

// pt
import vavaTitBgPt from './images/vava/female-bg-pt.png'
import echoTitBgPt from './images/echo/female-bg-pt.png'
import joychatTitBgPt from './images/joychat/female-bg-pt.png'
import kikoTitBgPt from './images/kiko/female-bg-pt.png'

// tr
import vavaTitBgTr from './images/vava/female-bg-tr.png'
import echoTitBgTr from './images/echo/female-bg-tr.png'
import joychatTitBgTr from './images/joychat/female-bg-tr.png'
import kikoTitBgTr from './images/kiko/female-bg-tr.png'

// ar
import vavaTitBgAr from './images/vava/female-bg-ar.png'
import echoTitBgAr from './images/echo/female-bg-ar.png'
import joychatTitBgAr from './images/joychat/female-bg-ar.png'
import kikoTitBgAr from './images/kiko/female-bg-ar.png'

// fr
import vavaTitBgFr from './images/vava/female-bg-fr.png'
import echoTitBgFr from './images/echo/female-bg-fr.png'
import joychatTitBgFr from './images/joychat/female-bg-fr.png'
import kikoTitBgFr from './images/kiko/female-bg-fr.png'

// id
import vavaTitBgId from './images/vava/female-bg-id.png'
import echoTitBgId from './images/echo/female-bg-id.png'
import joychatTitBgId from './images/joychat/female-bg-id.png'
import kikoTitBgId from './images/kiko/female-bg-id.png'

const imgsMap = {
  'tit-bg-en': {
    vava: vavaTitBgEn,
    echo: echoTitBgEn,
    joychat: joychatTitBgEn,
    kiko: kikoTitBgEn
  },
  'tit-bg-es': {
    vava: vavaTitBgEs,
    echo: echoTitBgEs,
    joychat: joychatTitBgEs,
    kiko: kikoTitBgEs
  },
  'tit-bg-pt': {
    vava: vavaTitBgPt,
    echo: echoTitBgPt,
    joychat: joychatTitBgPt,
    kiko: kikoTitBgPt
  },
  'tit-bg-tr': {
    vava: vavaTitBgTr,
    echo: echoTitBgTr,
    joychat: joychatTitBgTr,
    kiko: kikoTitBgTr
  },
  'tit-bg-fr': {
    vava: vavaTitBgFr,
    echo: echoTitBgFr,
    joychat: joychatTitBgFr,
    kiko: kikoTitBgFr
  },
  'tit-bg-ar': {
    vava: vavaTitBgAr,
    echo: echoTitBgAr,
    joychat: joychatTitBgAr,
    kiko: kikoTitBgAr
  },
  'tit-bg-id': {
    vava: vavaTitBgId,
    echo: echoTitBgId,
    joychat: joychatTitBgId,
    kiko: kikoTitBgId
  }
}

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      packageName: '',
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0
      },
      canClaim: 'canNotClaim',
      mePosition: '7%',
      showReward: false,
      reward: 0,
      loading: false
    }
  },
  methods: {
    getMatchTitle(imgnamePre, lang) {
      let imgname = imgnamePre + lang
      if (!imgsMap[imgname]) {
        imgname = imgnamePre + 'en'
      }
      if (imgsMap[imgname]) {
        // 按包名判断
        const appName = this.getAppName()
        if (this.appNameFlag('vava', appName)) {
          return imgsMap[imgname]['vava']
        }
        if (this.appNameFlag('echo', appName)) {
          return imgsMap[imgname]['echo']
        }
        if (this.appNameFlag('joychat', appName)) {
          return imgsMap[imgname]['joychat']
        }
        if (this.appNameFlag('kiko', appName)) {
          return imgsMap[imgname]['kiko']
        }
      }
      return ''
    },
    handleToRule() {
      this.$router.push({ path: '/newyearsday-rules-female', query: { from: 'newyearsday-main-female' } })
    },
    handleToRank() {
      this.$router.push({ path: '/newyearsday-rank-female', query: { from: 'newyearsday-main-female' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/newyearsday-rank-female' })
    },
    handleGotIt() {
      this.closeWeb()
    },
    handleClaim() {
      if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length) {
        if (this.actInfo.milestoneStates.some((item) => item === 1)) {
          if (this.loading) {
            return
          }
          this.loading = true

          holidayMilesClaim()
            .then((resData) => {
              if (resData && !resData.error) {
                this.showReward = true
                this.reward = resData.data
                this.fetchData()
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          // mock
          // this.actInfo.milestoneStates = [0, 1, 2]
          // this.actInfo.milestoneRewards = [70, 70, 70]

          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            this.initCountDown(resData.endTimestamp, true, true)
          }

          if (this.actInfo.leaderboardRewards && this.actInfo.leaderboardRewards.length) {
            this.boardData.num1Reward = this.actInfo.leaderboardRewards[0] || 0
            this.boardData.num2Reward = this.actInfo.leaderboardRewards[1] || 0
            this.boardData.num3Reward = this.actInfo.leaderboardRewards[2] || 0
            this.boardData.num4Reward = this.actInfo.leaderboardRewards[3] || 0
          }

          if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length) {
            // 可领取
            let claimStatus = 'canNotClaim'
            if (this.actInfo.milestoneStates.some((item) => item === 1)) {
              claimStatus = 'canClaim'
            }
            if (this.actInfo.milestoneStates.every((item) => item === 2)) {
              claimStatus = 'claimed'
            }
            this.canClaim = claimStatus

            if (this.actInfo.score < 10) {
              this.mePosition = '7%'
            }

            if (this.actInfo.score === 10) {
              this.mePosition = '12.6%'
            }

            if (this.actInfo.score > 10 && this.actInfo.score < 30) {
              this.mePosition = '35%'
            }

            if (this.actInfo.score === 30) {
              this.mePosition = '55%'
            }

            if (this.actInfo.score > 30 && this.actInfo.score < 50) {
              this.mePosition = '75%'
            }

            if (this.actInfo.score >= 50) {
              this.mePosition = '100%'
            }
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
.holiday-main-root {
  width: 100%;
  min-height: 100vh;
  background: #ff4d47;

  .custom-nav-block {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .holiday-con {
    .holiday-head {
      width: 100%;
      min-height: 370px;
      font-size: 0;
      position: relative;
      .head-img-back {
        width: 100%;
      }
      .head-con {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        width: 100%;
        min-height: 370px;
        .head-img {
          width: 100%;
          min-height: 90px;
          img {
            display: block;
            width: 100%;
          }
        }

        .dead-line {
          width: 190px;
          height: 28px;
          margin: 0 auto;
          padding: 0 24px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 40px;
          background: #fff;

          .timer {
            display: flex;
            align-items: center;
            justify-content: center;
            > span {
              color: #b81439;
              text-align: center;
              font-family: 'TikTok Sans';
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 21px;
              display: flex;
              align-items: flex-end;
              i {
                font-size: 16px;
                line-height: 21px;
              }
            }
            .stp {
              padding: 0 1px;
            }
            .time-num {
              span {
                width: 23px;
                text-align: center;
              }
            }
          }
        }

        .points-rank {
          width: 100%;
          margin-top: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          .pr-item {
            flex: 1;
            height: 66px;
            padding: 10px;
            background: #fafaf2;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            div:nth-child(1) {
              font-family: TikTok Sans;
              font-weight: 400;
              font-size: 15px;
              color: #c12240;
              line-height: 20px;
            }
            div:nth-child(2) {
              font-family: TikTok Sans;
              font-weight: bold;
              font-size: 20px;
              color: #c12240;
              line-height: 24px;
            }
          }
          .pr-gap {
            width: 15px;
          }
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -30px;

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #fffdf0;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 42px;
          background: #ffe8b8;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          span {
            color: #c12240;
            font-family: 'TikTok Sans';
            font-size: 17px;
            font-weight: bold;
          }
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTok Sans;
          font-size: 15px;
          color: #be2a32;
          line-height: 22px;
          font-weight: normal;
        }

        .holiday-gift {
          width: 100%;
          min-height: 30px;
          margin: 0 auto 16px;
          padding: 0 10px;
          display: flex;
          align-items: flex-start;
          justify-content: space-evenly;
          .gift-round {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .gift-cost {
              border-radius: 19px;
              background: #ff4d47;
              padding: 2px 4px;
              min-width: 36px;
              font-family: TikTok Sans;
              font-weight: 600;
              font-size: 8px;
              color: #ffffff;
              line-height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              transform: translateY(50%);
            }
            .gift-img {
              padding: 13px 5px 5px 5px;
              border-radius: 8px;
              background: #ffffff;
              img {
                width: 40px;
                height: 40px;
                margin-top: 6px;
              }
            }
            .gift-name {
              font-family: TikTok Sans;
              font-weight: 400;
              font-size: 12px;
              color: #be2a32;
              line-height: 16px;
              margin-top: 4px;
              text-align: center;
            }
          }
        }

        .holiday-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .holiday-item {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 15px;
            color: #af2f3a;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              color: #af2f3a;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }

        .part-percent {
          width: 100%;
          padding: 0 16px 0;
          .progress-box {
            width: 300px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            > div {
              display: flex;
              flex-direction: column;
              .box-top {
                min-width: 52px;
                min-height: 31px;
                padding: 0 5px;
                background: url(./images/tip-wrap.png) left top / 100% 100% no-repeat;
                > div {
                  color: #fff;
                  font-family: 'TikTok Sans';
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 20px;
                  padding-top: 2px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  img {
                    width: 14px;
                    height: 14px;
                    margin: 0 2px;
                  }
                }
              }
              .box {
                width: 34px;
              }
              .sharking {
                // animation: shake 1.5s infinite linear;
                // transform-origin: center bottom;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(20px);
              }
              &:nth-child(2) {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(15px);
              }
              &:nth-child(3) {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                transform: translateX(15px);
              }
            }
          }
          .progress-wraper {
            width: 286px;
            height: 20px;
            margin: 5px auto 0;
            display: flex;
            align-items: center;
            .progress-bar {
              width: 100%;
              height: 8px;
              border-radius: 100px;
              background: #fff1c2;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              position: relative;
              overflow: visible;

              .step {
                width: 14px;
                height: 14px;
                border-radius: 12px;
                border-radius: 12px;
                border: 2px solid #fff;
                background: #fff1c2;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                z-index: 9;
                &.on {
                  border: 2px solid #fff;
                  background: #ff4906;
                }
              }
              .step0 {
                left: 36px;
              }
              .step1 {
                left: calc(50% + 18px);
                margin-left: -7px;
              }
              .step5 {
                left: 100%;
                margin-left: -7px;
              }

              .progress-trace {
                width: 20px;
                height: 100%;
                border-radius: 100px;
                background: linear-gradient(90deg, #ffd280 0%, #f62b40 73.57%), #ff4906;
                position: relative;
                overflow: visible;
                .me {
                  position: absolute;
                  top: 50%;
                  right: -16px;
                  z-index: 99;
                  margin-top: -10px;
                  width: 31px;
                  height: 20px;
                  background: url(./images/progress-me.png) left top / 100% 100% no-repeat;
                }
              }
            }
          }
          .progress-points {
            width: 100%;
            height: 20px;
            margin: 0 auto;
            display: flex;
            align-items: center;

            .points-name {
              width: 50px;
              color: #af2f3a;
              font-family: 'TikTok Sans';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }
            .points-num {
              flex: 1;
              color: #af2f3a;
              font-family: 'TikTok Sans';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;

              display: flex;
              align-items: center;
              justify-content: space-between;
              > div {
                &:nth-child(1) {
                  transform: translateX(5px);
                }
                &:nth-child(2) {
                  transform: translateX(-6px);
                }
                &:nth-child(3) {
                  transform: translateX(-11px);
                }
              }
            }
          }
        }

        .task-item {
          padding: 0 16px;
          margin-bottom: 20px;
          position: relative;
          .task-item-tit {
            color: #be2a32;
            font-family: 'TikTok Sans';
            font-size: 15px;
            display: flex;
            align-items: center;
            span {
              color: #be2a32;
            }
            i {
              color: #bda4a7;
            }
          }
          .task-item-reward {
            margin-top: 6px;
            display: flex;
            align-items: center;
            .task-item-gap {
              width: 10px;
            }
            .task-item-gift {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .item-gift-img {
                border-radius: 6px;
                width: 38px;
                height: 38px;
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 30px;
                }
              }
              .item-gift-num {
                margin-top: 4px;
                color: #af2f3a;
                font-family: 'TikTok Sans';
                font-size: 12px;
                font-style: italic;
                font-weight: 700;
              }
            }
          }
          .task-item-btn {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            text-align: center;
            font-family: 'TikTok Sans';
            font-size: 16px;
            font-weight: 600;
            border-radius: 30px;
            min-width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 22px;
            }
          }
          .task-item-btn.blue {
            background: #ff4140;
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.yellow {
            background: #ffb92a;
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.disable {
            background: #f2eded;
            color: #bda4a7;
            font-weight: 400;
          }
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .holiday-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 30px;
          background: #ff4140;
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            opacity: 0.4;
          }
        }
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  overflow-y: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  .dia-con {
    width: 315px;
    padding: 30px 16px;
    border-radius: 16px;
    background: #fffcf0;

    .reward-item {
      margin-top: 24px;
      padding-bottom: 6px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        margin: 0 4px;
      }

      span {
        font-family: RobotoFlex;
        font-weight: bold;
        font-size: 20px;
        color: #be2a32;
        line-height: 28px;
        text-align: center;
      }
    }

    .dia-tips {
      width: 100%;
      font-family: RobotoFlex;
      font-size: 17px;
      color: #be2a32;
      line-height: 18px;
      text-align: center;
      margin-bottom: 16px;
    }

    .rules-btn {
      width: 255px;
      line-height: 26px;
      margin: 0 auto;
      padding: 10px 15px;
      border-radius: 30px;
      background: #ff4140;
      font-family: TikTok Sans;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
    }
  }
}

html[lang='ar'] {
  .holiday-main-root .holiday-con .main-con .part-block .task-item .task-item-btn {
    right: unset;
    left: 16px;
  }
}
</style>
